// extracted by mini-css-extract-plugin
export default {"page_title":"style_page_title__dMxfw","title":"style_title__SnC-R","sub_title":"style_sub_title__Kg-Wi"};